import { render, staticRenderFns } from "./ElementPanel.vue?vue&type=template&id=ffe18f48&scoped=true&"
import script from "./ElementPanel.vue?vue&type=script&lang=js&"
export * from "./ElementPanel.vue?vue&type=script&lang=js&"
import style0 from "./ElementPanel.vue?vue&type=style&index=0&id=ffe18f48&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe18f48",
  null
  
)

export default component.exports